import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {debounce} from 'throttle-debounce'
import {Select, Spin} from 'antd'

import style from './tickerSearch.sass'

@inject('store') @observer
class TickerSearch extends Component {
  constructor(props) {
    super(props)
    this.debouncedSearch = debounce(500, this.asyncSearch)
  }
  asyncSearch = (value) => {
    const {analysis, symbols} = this.props.store
    const type = analysis.has_coins ? 3 : 1
    symbols.search(value, type)
  }
  changeTicker = (value, elem) => {
    const {company} = elem.props
    this.props.store.analysis.change('ticker', value)
    this.props.store.analysis.change('tickerName', value)
    this.props.store.analysis.change('company', company)
    this.props.store.analysis.loadCandlestick()
  }
  handleFocus = () => this.debouncedSearch('')

  render() {
    const {symbols} = this.props.store
    return(
      <div styleName='wrapper'>
        <Select
          showSearch
          placeholder='Search'
          onChange={this.changeTicker}
          onSearch={this.debouncedSearch}
          onFocus={this.handleFocus}
          notFoundContent={symbols.searching ? <Spin size='small'/> : null}
          dropdownMatchSelectWidth={false}
          showArrow={false}
          optionLabelProp='data-name'
          filterOption={false}
        >
          {symbols.list.map(sym =>
            <Select.Option
              key={sym.symbol}
              company={sym.symbol_name}
              value={sym.symbol}
              data-name={sym.symbol_name}
            >
              {sym.symbol.replace(/^CRYPTO-/, '')}{sym.symbol_name ? ' - ' + sym.symbol_name : ''}
            </Select.Option>
          )}
        </Select>
      </div>
    )
  }
}

export default TickerSearch
